import React, { useState, useEffect } from 'react';
import ColorInit from "../helper/ColorInit";
import HeaderOne from "../components/HeaderTwo";
import BottomFooter from "../components/BottomFooter";

const ReturnPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    quick_summary: true,
    how_it_works: false,
    returns: false,
    refunds: false,
    replacements: false,
    exclusions: false,
    shipping_address: false,
    timing: false
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPolicy();
  }, []);

  const fetchPolicy = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/return-policy/`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch return policy: ${response.status}`);
      }

      const data = await response.json();
      setPolicy(data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching return policy:', err);
      setError('Failed to load return policy information');
      setLoading(false);
    }
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleAllSections = (expand) => {
    setExpandedSections({
      quick_summary: expand,
      how_it_works: expand,
      returns: expand,
      refunds: expand,
      replacements: expand,
      exclusions: expand,
      shipping_address: expand,
      timing: expand
    });
  };

  const palette = {
    lightMint: "#C3DCD8",
    softGrey: "#DBD9DA",
    mutedGold: "#C5BD96",
    mutedTeal: "#93B0AC",
    bgWhite: "#F9FAFB",
    bgIce: "#F2F8F6"
  };

  const cardStyle = (expanded, topColor = palette.lightMint) => ({
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    marginBottom: "28px",
    border: `2px solid ${palette.softGrey}`,
    boxShadow: "0 4px 20px rgba(138, 127, 141, 0.06)",
    borderTop: `3px solid ${topColor}`,
    overflow: "hidden",
    transition: "all 0.3s ease",
    cursor: "pointer"
  });

  if (loading) return (
    <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
      <p style={{ fontSize: "1.5rem", color: palette.mutedTeal }}>Loading return policy...</p>
    </div>
  );
  if (error) return (
    <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
      <p style={{ fontSize: "1.5rem", color: "#E6A4B4" }}>{error}</p>
    </div>
  );
  if (!policy) return (
    <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
      <p style={{ fontSize: "1.5rem", color: palette.mutedTeal }}>No return policy available.</p>
    </div>
  );

  return (
    <>
      <ColorInit color={true} />
      <HeaderOne category={true} />

      <section id="main-content" className="wrapper main-wrapper">
        <div className="return-policy" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", backgroundColor: "#FAF9F6" }}>

          {/* Hero Section */}
          <section
            style={{
              background: "linear-gradient(135deg, #1D2A3A 0%, #2C3E50 100%)",
              padding: "80px 20px",
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
              marginBottom: "40px"
            }}
          >
            <div className="hero-glow" style={{
              position: "absolute",
              top: "-50%",
              left: "-20%",
              width: "140%",
              height: "200%",
              background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
              pointerEvents: "none"
            }}></div>

            <div style={{ maxWidth: "900px", margin: "0 auto", position: "relative", zIndex: 1 }}>
              <h1
                style={{
                  fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                  fontWeight: "800",
                  marginBottom: "20px",
                  color: "white",
                  textShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                {policy.hero_title || "Return & Refund Policy"}
              </h1>
              <p
                style={{
                  fontSize: "1.25rem",
                  color: "white",
                  opacity: "0.95",
                  lineHeight: "1.6",
                  maxWidth: "700px",
                  margin: "0 auto"
                }}
              >
                {policy.hero_subtitle || "Easy Returns & Hassle-Free Refunds"}
              </p>
            </div>
          </section>

          <div
            className="return-policy__container"
            style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
          >
            {/* Expand/Collapse All Buttons */}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginBottom: "30px",
              flexWrap: "wrap"
            }}>
              <button
                onClick={() => toggleAllSections(true)}
                style={{
                  backgroundColor: palette.lightMint,
                  color: palette.mutedTeal,
                  border: "none",
                  padding: "10px 24px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(195, 220, 216, 0.3)"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = palette.mutedTeal;
                  e.currentTarget.style.color = "white";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = palette.lightMint;
                  e.currentTarget.style.color = palette.mutedTeal;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Expand All
              </button>
              <button
                onClick={() => toggleAllSections(false)}
                style={{
                  backgroundColor: "white",
                  color: palette.mutedTeal,
                  border: `2px solid ${palette.lightMint}`,
                  padding: "8px 24px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = palette.bgIce;
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Collapse All
              </button>
            </div>

            {/* Quick Summary Section */}
            <section style={{ marginBottom: "50px" }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                  Quick Summary
                </h2>
              </div>

              <div
                style={cardStyle(expandedSections.quick_summary, palette.mutedGold)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.quick_summary ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("quick_summary")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.quick_summary ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.quick_summary ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    Key Policy Points
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.quick_summary ? "Hide Summary \u2014" : "Show Summary +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.quick_summary ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.quick_summary ? "5000px" : "0", opacity: expandedSections.quick_summary ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                >
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "24px" }}>
                    {[
                      { icon: policy.qs_1_icon, title: policy.qs_1_title, desc: policy.qs_1_desc, color: palette.lightMint },
                      { icon: policy.qs_2_icon, title: policy.qs_2_title, desc: policy.qs_2_desc, color: palette.mutedTeal },
                      { icon: policy.qs_3_icon, title: policy.qs_3_title, desc: policy.qs_3_desc, color: palette.mutedGold },
                      { icon: policy.qs_4_icon, title: policy.qs_4_title, desc: policy.qs_4_desc, color: palette.softGrey }
                    ].map((item, idx) => (
                      <div key={idx} style={{ display: "flex", gap: "15px", alignItems: "flex-start" }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: palette.bgIce, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <span className={item.icon} style={{ color: palette.mutedTeal, fontSize: "1.2rem" }}></span>
                        </div>
                        <div>
                          <h4 style={{ margin: "0 0 5px 0", color: palette.mutedTeal, fontSize: "1.05rem", fontWeight: "600" }}>{item.title}</h4>
                          <p style={{ margin: 0, fontSize: "0.95rem", color: "#6B7280" }}>{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* How It Works Section */}
            <section style={{ marginBottom: "50px" }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                  {policy.how_title || "How It Works"}
                </h2>
              </div>

              <div
                style={cardStyle(expandedSections.how_it_works, palette.lightMint)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.how_it_works ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("how_it_works")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.how_it_works ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.how_it_works ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    Return Process
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.how_it_works ? "Hide Steps \u2014" : "Show Steps +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.how_it_works ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.how_it_works ? "5000px" : "0", opacity: expandedSections.how_it_works ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                >
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "30px" }}>
                    {[
                      { icon: policy.hw_1_icon, title: policy.hw_1_title, desc: policy.hw_1_desc },
                      { icon: policy.hw_2_icon, title: policy.hw_2_title, desc: policy.hw_2_desc },
                      { icon: policy.hw_3_icon, title: policy.hw_3_title, desc: policy.hw_3_desc },
                      { icon: policy.hw_4_icon, title: policy.hw_4_title, desc: policy.hw_4_desc }
                    ].map((step, idx) => (
                      <div key={idx} style={{ textAlign: "center", padding: "20px", borderRadius: "12px", border: `1px solid ${palette.bgIce}`, backgroundColor: palette.bgWhite }}>
                        <div style={{ width: "60px", height: "60px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 15px", border: `2px solid white`, boxShadow: "0 4px 10px rgba(0,0,0,0.05)" }}>
                          <span className={step.icon} style={{ color: palette.mutedTeal, fontSize: "1.8rem" }}></span>
                        </div>
                        <h4 style={{ color: palette.mutedTeal, fontSize: "1.2rem", fontWeight: "700", marginBottom: "10px" }}>{step.title}</h4>
                        <p style={{ margin: 0, fontSize: "0.95rem", lineHeight: "1.6" }}>{step.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Detailed Policy Sections */}
            <section style={{ marginBottom: "50px" }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                  {policy.section_title || "Policy Details"}
                </h2>
              </div>

              {/* Returns */}
              <div
                style={cardStyle(expandedSections.returns, palette.mutedGold)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.returns ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("returns")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.returns ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.returns ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    Returns
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.returns ? "Hide Info \u2014" : "Show Info +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.returns ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.returns ? "5000px" : "0", opacity: expandedSections.returns ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                  dangerouslySetInnerHTML={{ __html: policy.return_text }}
                />
              </div>

              {/* Refunds */}
              <div
                style={cardStyle(expandedSections.refunds, palette.lightMint)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.refunds ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("refunds")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.refunds ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.refunds ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    Refunds
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.refunds ? "Hide Info \u2014" : "Show Info +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.refunds ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.refunds ? "5000px" : "0", opacity: expandedSections.refunds ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                  dangerouslySetInnerHTML={{ __html: policy.refund_text }}
                />
              </div>

              {/* Replacements */}
              <div
                style={cardStyle(expandedSections.replacements, palette.mutedGold)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.replacements ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("replacements")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.replacements ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.replacements ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    Replacements
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.replacements ? "Hide Info \u2014" : "Show Info +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.replacements ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.replacements ? "5000px" : "0", opacity: expandedSections.replacements ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                  dangerouslySetInnerHTML={{ __html: policy.replace_text }}
                />
              </div>

              {/* Exclusions */}
              <div
                style={cardStyle(expandedSections.exclusions, palette.softGrey)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.exclusions ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("exclusions")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.exclusions ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.exclusions ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    {policy.exclusions_title || "Policy Exclusions"}
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.exclusions ? "Hide Info \u2014" : "Show Info +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.exclusions ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.exclusions ? "5000px" : "0", opacity: expandedSections.exclusions ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                >
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    {policy.exclusions_list && policy.exclusions_list.split("\r\n").map((item, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>{item.trim()}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Shipping Address */}
              <div
                style={cardStyle(expandedSections.shipping_address, palette.lightMint)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.shipping_address ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("shipping_address")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.shipping_address ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.shipping_address ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    {policy.address_title || "Return Address"}
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.shipping_address ? "Hide Address \u2014" : "Show Address +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.shipping_address ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.shipping_address ? "5000px" : "0", opacity: expandedSections.shipping_address ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                >
                  <p style={{ marginBottom: "15px" }}>{policy.address_intro}</p>
                  <div
                    style={{ backgroundColor: palette.bgIce, padding: "20px", borderRadius: "10px", borderLeft: `4px solid ${palette.lightMint}` }}
                    dangerouslySetInnerHTML={{ __html: policy.address_block ? policy.address_block.replace(/\r\n/g, "<br/>") : "" }}
                  />
                </div>
              </div>

              {/* Timing */}
              <div
                style={cardStyle(expandedSections.timing, palette.mutedGold)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                  e.currentTarget.style.borderColor = palette.lightMint;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                  e.currentTarget.style.borderColor = palette.softGrey;
                }}
              >
                <div
                  style={{
                    backgroundColor: palette.bgIce,
                    padding: "24px 30px",
                    borderBottom: expandedSections.timing ? `2px solid ${palette.lightMint}` : "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  onClick={() => toggleSection("timing")}
                >
                  <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                    <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.timing ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.timing ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                    </span>
                    {policy.timing_title || "Timing & Turnaround"}
                  </h3>
                  <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                    {expandedSections.timing ? "Hide Info \u2014" : "Show Info +"}
                  </span>
                </div>
                <div
                  style={{ padding: expandedSections.timing ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.timing ? "5000px" : "0", opacity: expandedSections.timing ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                >
                  <p style={{ marginBottom: "15px" }}>{policy.timing_text}</p>
                  <p style={{ backgroundColor: palette.bgIce, padding: "15px", borderRadius: "10px", fontStyle: "italic", color: palette.mutedTeal, fontWeight: "600" }}>{policy.timing_highlight}</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <BottomFooter />
    </>
  );
};

export default ReturnPolicy;